<template>
  <div>
    <NuxtLazyHydrate when-idle>
      <NuxtLoadingIndicator color="#4ab5bd" :throttle="0" />
    </NuxtLazyHydrate>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup lang="ts">
import { useCheckForAppUpdates } from '~/composables/useCheckForAppUpdates'
import { useAffiliateTracking } from '~/composables/useAffiliateTracking'
import { useSocialLoginTracking } from '~/composables/useSocialLoginTracking'
import { useVwoScript } from '~/composables/useVwoScript'
import { useMidaScript } from '~/composables/useMidaScript'
import { useBodyScrollLockRouteSync } from '~/composables/useBodyScrollLock'
import { useSearchEngineForceHead } from '~/composables/search/useSearchEngineForceHead'

const { checkForAppUpdates } = useCheckForAppUpdates()
// Reliably release the drawer body scroll lock on every navigation, even onto
// pages that don't mount the drawer components (e.g. blank-layout checkout)
useBodyScrollLockRouteSync()
// Initialize affiliate tracking
useAffiliateTracking()
// Fire the social-login GTM event on the post-login destination (KFT-3806)
useSocialLoginTracking()
// Expose window.kftSearchEngine.force before any A/B tool loads (KFT-4115)
useSearchEngineForceHead()
// Initialize VWO A/B testing (only in production, excludes embedded/widgets/booking solution)
useVwoScript()
// Initialize Mida A/B testing (only in production, excludes embedded/widgets/booking solution)
useMidaScript()

const handlePageShow = (evt: PageTransitionEvent) => {
  if (evt.persisted) {
    setTimeout(function () {
      window.location.reload()
    }, 10)
  }
}

onMounted(() => {
  usePollingWhenTabActive(checkForAppUpdates, 60 * 60 * 1000)
  window.addEventListener('pageshow', handlePageShow, false)
})

onUnmounted(() => {
  window.removeEventListener('pageshow', handlePageShow, false)
})
</script>
